var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scrollDelta > 0)?_c('img',{class:_vm._.backTop,attrs:{"src":require('./images/回顶.png')},on:{"click":_vm.handleBackTopClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }